export default __webpack_public_path__ + "static/media/ios.45aa00e1.svg";